import api from "@/modules/global/lib/api-client.js";
import cloneDeep from "lodash/cloneDeep";

const defaultState = {
  jwtString: null,
  jwtExpiry: null,
  isAuthenticated: false,
  user: {
    _id: null,
    name: null,
    email: null
  },
  responseObject: null
};

export default {
  namespaced: true,
  state: cloneDeep(defaultState),
  getters: {
    getIsAuthenticated: state => {
      return state.isAuthenticated;
    },
    getJWTString: state => {
      return state.jwtString;
    },
    getResponseObject: state => {
      return state.responseObject;
    },
    getMyId: state => {
      return state.user._id;
    }
  },
  mutations: {
    updateJWTParams(state, val) {
      state.jwtString = val.jwtString;
      state.jwtExpiry = val.jwtExpiry;
    },
    setAuthentication(state, val) {
      state.isAuthenticated = val;
    },
    setUser(state, val) {
      state.user.name = val.isProject ? val.user.firstName : val.user.name;
      state.user._id = val.user._id;
      state.user.email = val.user.email;
    },
    saveResponseObject(state, val) {
      state.responseObject = val;
    },
    resetState(state) {
      const s = cloneDeep(defaultState);
      Object.keys(s).forEach(key => {
        state[key] = s[key];
      });
    }
  },
  actions: {
    resetState({ commit }) {
      commit("resetState");
    },
    async fetchMyDetails({ dispatch, commit }, userId) {
      let request = await api.get(`login/${userId}`);
      if (request.ok) {
        let response = await request.json();
        commit("updateJWTParams", {
          jwtString: response.jwtString,
          jwtExpiry: response.jwtPayload.exp
        });
        commit("setUser", {
          user: response.jwtPayload.user,
          isProject: response.jwtPayload.isProject
        });
        commit("saveResponseObject", response);
        dispatch("handleFetchMyDetailsResponse", response);
        return true;
      } else {
        commit("setAuthentication", false);
        return false;
      }
    },
    handleFetchMyDetailsResponse({ dispatch, commit }, response) {
      commit("setAuthentication", true);
      dispatch("updateProjectRelatedFields", response);
    },
    updateProjectRelatedFields({ dispatch, commit }, payload) {
      commit("globalStore/setIsProject", payload.jwtPayload.isProject, {
        root: true
      });
      if (payload.jwtPayload.isProject) {
        if (payload.jwtPayload.user.project) {
          commit("globalStore/updateIsInternal", false, { root: true });
          dispatch(
            "globalStore/setupProject",
            {
              project: payload.jwtPayload.user.project,
              projectName: payload.jwtPayload.user.projectName,
              country: payload.jwtPayload.user.country,
              isMatricAssessment: payload.jwtPayload.user.isMatricAssessment,
              schools: payload.clientSideData.filters.schools
            },
            { root: true }
          );
          dispatch(
            "globalStore/updateActiveFields",
            {
              project: payload.jwtPayload.user.project,
              projectName: payload.jwtPayload.user.projectName,
              isMatricAssessment: payload.jwtPayload.user.isMatricAssessment,
              country: payload.jwtPayload.user.country
            },
            {
              root: true
            }
          );
        } else {
          commit("globalStore/updateIsInternal", true, { root: true });
          dispatch(
            "globalStore/loadProjects",
            payload.clientSideData.filters.projects,
            { root: true }
          );
        }
      } else {
        commit("globalStore/updateIsInternal", false, { root: true });
        dispatch(
          "globalStore/setupCompanyProject",
          {
            company: payload.jwtPayload.user.companyName,
            companyId: payload.jwtPayload.user.companyId,
            companyName: payload.jwtPayload.user.companyName,
            tutors: payload.jwtPayload.user.tutors
          },
          { root: true }
        );
        dispatch(
          "globalStore/updateActiveFields",
          {
            project: payload.jwtPayload.user.companyName,
            projectName: payload.jwtPayload.user.companyName,
            isMatricAssessment: false,
            country: payload.jwtPayload.user.country
          },
          {
            root: true
          }
        );
      }
    }
  }
};
